import { render } from "./TicketDetails.vue?vue&type=template&id=65c6ad90&scoped=true"
import script from "./TicketDetails.vue?vue&type=script&lang=js"
export * from "./TicketDetails.vue?vue&type=script&lang=js"

import "./TicketDetails.vue?vue&type=style&index=0&id=65c6ad90&scoped=true&lang=css"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65c6ad90"]])

export default __exports__